<template>
  <div>
    <nav-bar :title="'About'" />
    <div class="mobile none-padding-mobile pt-4 position-relative">
      <b-container>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <about-skeleton />
          </template>
          <loading-overlay :isLoading="loadingSearch">
            <template #text>
              <span>Wait a moment</span>
            </template>
            <template>
              <b-row v-if="aboutUsInfo" class="mt-3 mb-0 mx-0 py-2">
                <b-col cols="12">
                  <b-card-text>
                    <span class="about-container_embed" v-html="$sanitize(aboutUsInfo)"></span>
                  </b-card-text>
                </b-col>
              </b-row>
              <div v-if="faqs">
                <about-faqs :faqs="faqs" :topics="topics" @onSearch="getFaqs"></about-faqs>
              </div>
            </template>
            <div>
              <about-comments
                :userEmail="userEmail"
                @onSubmitCommentForm="handleComments"
              ></about-comments>
            </div>
          </loading-overlay>
        </b-skeleton-wrapper>
      </b-container>
    </div>
  </div>
</template>

<script>
import { getAboutUsInfo, getFAQS, sentComment, getFAQSTopics } from '@/common/services';
import { modalsMixin } from '@/common/mixins/modals.mixins';
import { useSessionStore } from '@/common';

import { NavBar, LoadingOverlay } from '@/common/components';
import { AboutComments, AboutFaqs, AboutSkeleton } from '@/common/components/about';

export default {
  components: {
    NavBar,
    LoadingOverlay,
    AboutFaqs,
    AboutComments,
    AboutSkeleton,
  },
  mixins: [modalsMixin],
  data() {
    const sessionStore = useSessionStore();
    return {
      isLoading: true,
      loadingSearch: false,
      aboutUsInfo: '',
      faqs: [],
      topics: [],
      faqsInitialQuery: {
        search: '',
        type: '',
      },
      sessionStore,
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    userEmail() {
      return this.sessionStore.userEmail;
    },
  },
  async mounted() {
    this.isLoading = true;
    try {
      const [aboutUsInfo, faqs, topics] = await Promise.allSettled([
        getAboutUsInfo(),
        getFAQS(this.faqsInitialQuery),
        getFAQSTopics(),
      ]);
      this.aboutUsInfo = aboutUsInfo.value;
      this.faqs = faqs.value;
      this.topics = this.filterActiveTopics(topics.value);
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async handleComments({ userEmail = '', message = '' }) {
      try {
        const commentInformaion = {
          user_id: this.sessionStore.userId,
          email: userEmail,
          message,
          is_child: !this.userIsAParent,
        };
        await sentComment(commentInformaion);
        this.notificationOkModal('Your comment has been sent', {
          title: 'About',
          'ok-variant': 'success',
        });
      } catch (error) {
        console.log(error);
      }
    },
    filterActiveTopics(topics) {
      return topics.filter((topic) => topic.is_active);
    },
    async getFaqs({ search, type }) {
      this.loadingSearch = true;
      try {
        this.faqs = await getFAQS({ search, type });
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingSearch = false;
      }
    },
  },
};
</script>

<style lang="scss">
.about-container {
  &_embed {
    iframe {
      width: 100%;
      height: min(54vw, 54vh);
      border-radius: 8px;
    }
    img {
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
